// extracted by mini-css-extract-plugin
export default {"CourseItemWraper":"MyCourseItemWithOptions_CourseItemWraper__IqQDo"};